'use client'

import BodyText from '@lyra/core/components/BodyText'
import Countdown from '@lyra/core/components/Countdown'
import DataWithLabel from '@lyra/core/components/DataWithLabel'
import Section from '@lyra/core/components/Section'
import formatUSD from '@lyra/core/utils/formatUSD'
import EditUsernameButton from '@lyra/web/containers/common/EditUsernameButton'
import LeaderboardTable from '@lyra/web/containers/leaderboard/LeaderboardTable'
import useAuth from '@lyra/web/hooks/useAuth'
import useLeaderboard from '@lyra/web/hooks/useLeaderboard'
import useTradingRewards from '@lyra/web/hooks/useTradingRewards'
import React from 'react'

export default function LeaderboardPageHelper() {
  const {
    data: leaderboard,
    isLoading: isLoadingLeaderboard,
    error: errorLeaderboard,
  } = useLeaderboard()

  const { data: rewards, isLoading: isLoadingPoints, error: errorStats } = useTradingRewards()

  const { isAuthenticated, user } = useAuth()

  return (
    <>
      <Section isLarge noTopBorder justifyContent="center">
        <Section.PageHeader title="Leaderboard" subtitle="Top traders earning DRV and OP rewards" />
        <Section.Grid minColWidth={140} maxColWidth={160}>
          {isAuthenticated ? (
            <DataWithLabel
              label="Username"
              value={user?.username ?? user.address.slice(0, 6)}
              rightContent={<EditUsernameButton size="sm" label="Edit" />}
            />
          ) : null}
          <DataWithLabel
            label="Weekly Volume"
            value={rewards ? formatUSD(rewards.tradingStats?.totalVolume ?? 0, { dps: 0 }) : '...'}
          />
          <DataWithLabel
            label="Week Ends"
            tooltipTitleSameAsLabel
            tooltipContent="Rewards are distributed pro-rata based on points in weekly rounds. Rewards are claimable 1 week after a round ends."
            value={
              rewards ? <Countdown showDays endTimestamp={rewards.currRound.endTimestamp} /> : '...'
            }
          />
        </Section.Grid>
        {isLoadingLeaderboard || isLoadingPoints ? (
          <Section.Spinner />
        ) : errorLeaderboard || errorStats ? (
          <Section.XStack>
            <BodyText color="secondary">Something went wrong</BodyText>
          </Section.XStack>
        ) : leaderboard ? (
          <Section.Table>
            <LeaderboardTable leaderboard={leaderboard} />
          </Section.Table>
        ) : null}
      </Section>
    </>
  )
}
